module.exports = __webpack_public_path__ + "static/media/play.291a3cd0.svg";